module.exports = __webpack_public_path__ + "static/img/bg2.a405ce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/bg2.jpg
// module id = OYWs
// module chunks = 0